const s = {
  name: "WifiCross",
  dimensions: { width: 40, height: 38 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 39.6 38" style="enable-background:new 0 0 39.6 38;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M1.4,9.6C6.1,4.9,12.6,2,19.8,2s13.7,2.9,18.4,7.6l1.4-1.4C34.5,3.1,27.5,0,19.8,0S5.1,3.1,0,8.2L1.4,9.6z"/>
		<path class="st0" d="M5.7,13.9C9.3,10.2,14.3,8,19.8,8s10.5,2.2,14.1,5.9l1.4-1.4c-4-4-9.5-6.4-15.6-6.4S8.2,8.5,4.2,12.4
			L5.7,13.9z"/>
		<path class="st0" d="M19.8,14c-3.9,0-7.4,1.6-9.9,4.1l-1.4-1.4c2.9-2.9,6.9-4.7,11.3-4.7c4.4,0,8.4,1.8,11.3,4.7l-1.4,1.4
			C27.2,15.6,23.7,14,19.8,14z"/>
		<path class="st0" d="M19.8,20c-2.2,0-4.2,0.9-5.7,2.3l-1.4-1.4c1.8-1.8,4.3-2.9,7.1-2.9c2.8,0,5.3,1.1,7.1,2.9l-1.4,1.4
			C24,20.9,22,20,19.8,20z"/>
		<path class="st0" d="M18.4,31l-1.3-1.3l1.4-1.4l1.3,1.3l1.3-1.3l1.4,1.4L21.2,31l1.3,1.3l-1.4,1.4l-1.3-1.3l-1.3,1.3l-1.4-1.4
			L18.4,31z"/>
		<path class="st0" d="M19.8,24c-3.9,0-7,3.1-7,7s3.1,7,7,7s7-3.1,7-7S23.7,24,19.8,24z M14.8,31c0-2.8,2.2-5,5-5c2.8,0,5,2.2,5,5
			c0,2.8-2.2,5-5,5C17,36,14.8,33.8,14.8,31z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as WifiCross
};
